// extracted by mini-css-extract-plugin
export default {"NoticeWrapper":"Notice_NoticeWrapper__FrRSw","Notice":"Notice_Notice__xhWuu"};